import React from 'react';
const HistorialVentaProducto = (props) => {
   const { data, close }= props;
   const list = data.map((e,i)=>{
      return (
         <tr key={i} className={e.devolucion==="1"?'success':'warning'}>
            <td className='text-center'>{e.ventas.codigo}</td>
            <td className='text-center'>{e.nombre}</td>
            <td className='text-center'>{e.cantidad}</td>
            <td className='text-center'>{e.ventas.user}</td>
            <td className='text-center'>{e.devolucion==="1"?'No':'Si'}</td>
            <td className='text-center'>{e.created_at}</td>
         </tr>
      );
   })
   return (
      <div className='overlay large show'>
         <div className="row content">
            <div className="modal_header">
               <h5>DETALLES</h5>
               <span className="close-pop-up" onClick={close}>x</span>
            </div>
            <div className="modal_body vh-80">
               <h4>Sucursal: {data[0].sucursal}</h4>
               <label className="flex-label"><span className="spanSuccess quart"></span> Ventas</label>
               <label className="flex-label"><span className="spanWarning quart"></span> Cambios</label>
               <table>
                  <thead>
                     <tr>
                       <th>Ticket</th>
                       <th>Producto</th>
                       <th>Cantidad</th>
                       <th>Vendedor</th>
                       <th>Devolución</th>
                       <th>Fecha de venta</th>
                     </tr>
                  </thead>
                  <tbody>{list}</tbody>
               </table>
            </div>
         </div>
      </div>
   )
}
export {HistorialVentaProducto};